import { Component, OnInit } from '@angular/core';
import { AuthService } from "../core/auth.service";
import {config} from "../app.config";

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  form: any = {
    username: null,
    password: null
  };
  isLoggedIn = false;
  errorMessage = '';
  roles: string[] = [];
  alertMessage = "";
  alert = "";

  constructor(private authService: AuthService) {
  }

  ngOnInit(): void {
    if (this.authService.getToken()) {
      this.isLoggedIn = true;
    }
  }

  loginOAuth2(){
    this.authService.loginOAuth2();
  }
}
